import script from "./StructuredPrayerList.vue?vue&type=script&setup=true&lang=js"
export * from "./StructuredPrayerList.vue?vue&type=script&setup=true&lang=js"

import "./StructuredPrayerList.vue?vue&type=style&index=0&id=6bc24ed3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bc24ed3"]])

export default __exports__